<template>
  <div v-if="readPermission" class="tenantManagementContainer">
    <div class="configurePageContainer" style="height: 100%; width: 100%">
      <div v-if="isLoading" style="position: absolute; top: 50%; left: 65%; transform: translate(-50%, -50%); display: flex; justify-content: center; align-items: center">
        <div class="spinner-border text-primary spinner-grow-xl" role="status"></div>
      </div>

      <!-- Header with title and tenant selector -->
      <div v-if="!showAddForm && !showBlueprintModal" class="customRowTenant">
        <p class="jobHistoryTitle" style="text-align: left">IDP Document Classes</p>
        <div class="headerActions">
          <div class="searchBar">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <circle cx="6.5" cy="7.45996" r="5.75" stroke="#8F969B" stroke-width="1.5" />
              <path d="M11 11.96L15 15.96" stroke="#8F969B" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <input type="text" class="searchInput" placeholder="Search Document Classes" v-model="search" @input="handleSearchInput" />
            <div v-if="search && search.trim() !== ''" class="search-results">
              <span class="search-count">{{ totalFiltered }} of {{ total }} results</span>
            </div>
          </div>

          <!-- <div class="tenantSelector">
            <label for="tenantSelect">Select Tenant:</label>
            <select id="tenantSelect" v-model="selectedTenant" @change="onTenantChange" class="tenantDropdown">
              <option value="">Select Tenant</option>
              <option v-for="tenant in tenants" :key="tenant.id" :value="tenant.id">
                {{ tenant.name }}
              </option>
            </select>
          </div> -->
        </div>
      </div>

      <!-- Pagination Controls -->
      <div v-if="!showAddForm && !showBlueprintModal" class="tableHeadingsNew">
        <div class="tableHeadingsNew" style="margin-top: 20px">
          <div class="customRow">
            <CustomDropdown :label="$t('departments.select_tenant')" :placeholder="$t('departments.select_tenant')" v-model="selectedTenant" :options="tenants" :error="roleError" />
            <!-- <img src="/backward.svg" alt="Back" style="cursor: pointer" @click="goToPreviousPage" />
            <span class="pageOfTitle">Page {{ page }} of {{ totalPages }}</span>
            <img src="/forward.svg" alt="Next" style="cursor: pointer" @click="goToNextPage" />
            <div class="pageDiv" @click.stop="togglePageSizeDropdown">
              <span class="pageDivText">{{ pageSize }}</span>
              <img src="/arrowDownNew.png" class="arrowDownNew" alt="" />
              <ul ref="dropdownEl" v-if="showPageSizeDropdown" class="pageSizeDropdownNew" @click.stop>
                <li v-for="size in pageSizeOptions" :key="size" @click.stop="selectPageSize(size)">
                  {{ size }}
                </li>
              </ul>
            </div> -->
          </div>
        </div>
        <div style="display: flex; gap: 17px">
          <SecondaryButton v-if="writePermission" style="width: 200px" @click="handleAddClass">+ Add New Document Class</SecondaryButton>
        </div>
      </div>

      <!-- Add/Edit Class Form -->
      <div v-if="showAddForm && writePermission" class="createModelBody">
        <div class="createModelHeader">
          <svg @click="cancelAdd" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
            <path d="M5.25 11.25H20.25C20.45 11.25 20.64 11.33 20.78 11.47C20.92 11.61 21 11.8 21 12C21 12.2 20.92 12.39 20.78 12.53C20.64 12.67 20.45 12.75 20.25 12.75H5.25C5.05 12.75 4.86 12.67 4.72 12.53C4.58 12.39 4.5 12.2 4.5 12C4.5 11.8 4.58 11.61 4.72 11.47C4.86 11.33 5.05 11.25 5.25 11.25Z" fill="black" />
            <path d="M5.56 12L11.78 18.22C11.92 18.36 12 18.55 12 18.75C12 18.95 11.92 19.14 11.78 19.28C11.64 19.42 11.45 19.5 11.25 19.5C11.05 19.5 10.86 19.42 10.72 19.28L3.97 12.53C3.9 12.46 3.84 12.38 3.81 12.29C3.77 12.2 3.75 12.1 3.75 12C3.75 11.9 3.77 11.8 3.81 11.71C3.84 11.62 3.9 11.54 3.97 11.47L10.72 4.72C10.86 4.58 11.05 4.5 11.25 4.5C11.45 4.5 11.64 4.58 11.78 4.72C11.92 4.86 12 5.05 12 5.25C12 5.45 11.92 5.64 11.78 5.78L5.56 12Z" fill="black" />
          </svg>
          <span class="newPageTitle">{{ editMode ? 'Edit' : 'Add New' }} Document variant</span>
        </div>
        <div class="form-grid">
          <div class="form-field">
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px">
              <label class="form-label">Class Name</label>
              <button v-if="!editMode && !isCreatingNew" @click="toggleCreateNew" type="button" class="primary-btn create-new-btn">+ Create New</button>
            </div>
            <select v-if="!editMode && !isCreatingNew" v-model="classSelectionMode" @change="onClassSelectionChange" :class="{ 'error-border': showErrors && errors.name }" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px">
              <option value="">Select Class</option>
              <option v-for="className in uniqueClassNames" :key="className" :value="className">{{ className }}</option>
            </select>
            <div v-if="!editMode && isCreatingNew" style="display: flex; gap: 8px; align-items: center">
              <input type="text" v-model.trim="newClass.name" :class="{ 'error-border': showErrors && errors.name }" placeholder="Enter Class Name" style="flex: 1; padding: 8px; border: 1px solid #ccc; border-radius: 4px" />
              <button @click="cancelCreateNew" type="button" style="background: #6c757d; color: white; border: none; padding: 8px 12px; border-radius: 4px; font-size: 12px; cursor: pointer">Cancel</button>
            </div>
            <input v-if="editMode" type="text" v-model.trim="newClass.name" :class="{ 'error-border': showErrors && errors.name }" placeholder="Enter Class Name" />
            <span class="error-text" v-if="showErrors && errors.name">{{ errors.name }}</span>
          </div>
          <div class="form-field mt-2">
            <label>Document Type Variant Name</label>
            <input type="text" v-model.trim="newClass.description" :class="{ 'error-border': showErrors && errors.description }" placeholder="Enter Document Type Variant Name" />
            <span class="error-text" v-if="showErrors && errors.description">{{ errors.description }}</span>
          </div>
          <!-- <div class="form-field">
            <label>Is Active</label>
            <IsActiveComponentV1 v-model="newClass.is_active" @change="handleStatusChange" />
          </div> -->

          <div class="form-field">
            <label class="form-label">Upload Documents</label>
            <div class="uploadDivBorder" @click="triggerFileInput" @dragover.prevent="handleDragOver" @dragleave.prevent="handleDragLeave" @drop.prevent="handleDrop" :class="{ 'drag-over': isDragging }">
              <input type="file" ref="fileInput" style="display: none" @change="handleFileUpload" multiple accept=".pdf,.png,.jpg,.jpeg,.tiff,.tif,application/pdf,image/png,image/jpeg,image/tiff" />
              <img :src="uploadIcon" alt="Upload" />
              <p class="labelParagraph">
                <span class="subPageLabel">Drop your files here or</span><br />
                <span class="clickUploadLabel">Click to upload</span>
              </p>
              <p class="smallLabel">Supported formats: PDF, JPEG, PNG, TIFF</p>
              <p class="smallLabel">Max file size: 5 MB | Max pages (PDF): 10</p>
              <p class="smallLabel">Note: Upload only one document class/type per file.</p>
              <p v-if="fileErrorMessage" class="error-message">{{ fileErrorMessage }}</p>
            </div>

            <!-- Display uploaded files -->
            <div v-if="uploadedFiles?.length > 0" class="uploaded-files-section">
              <div class="files-container">
                <div v-for="(file, index) in uploadedFiles" :key="index" class="file-item">
                  <div class="file-info">
                    <img :src="pdfIcon" alt="File Icon" class="file-icon" />
                    <div class="file-group">
                      <span class="file-name">{{ file.name }}</span>
                      <span class="file-size">{{ formatFileSize(file.size) }}</span>
                    </div>
                    <img @click="removeFile(index)" class="remove-file" :src="closeIcon" alt="Remove" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="button-group">
          <button class="cancel-btn" @click="cancelAdd">Cancel</button>
          <button class="save-btn" @click="saveClass">Upload And Process</button>
        </div>
      </div>

      <!-- Classes Table -->
      <div v-if="!showAddForm && !showBlueprintModal" class="tableContainer" style="margin-top: 20px; max-height: 600px; overflow-y: auto">
        <table class="customTable">
          <thead class="customTableHeader">
            <tr class="customTableRow">
              <th>#</th>
              <th>Class Name</th>
              <th>Document Type Variant Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody class="customTableBody">
            <tr v-for="(docClass, index) in filteredClasses" :key="docClass.id" style="height: 50px !important">
              <td>{{ index + 1 + (page - 1) * pageSize }}</td>
              <td>{{ docClass?.ClassName }}</td>
              <td>{{ docClass?.BlueprintName }}</td>
              <td>
                <div class="action-buttons">
                  <CustomHyperlink v-if="writePermission" @click="viewBlueprint(docClass)" class="">View</CustomHyperlink>
                  <CustomHyperlink v-if="writePermission" @click="editBlueprint(docClass)" class="">Edit</CustomHyperlink>
                  <CustomHyperlink v-if="writePermission" @click="deleteBlueprint(docClass)" class="delete-link">Delete</CustomHyperlink>
                  <span v-if="!writePermission">-</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Confirmation Modals -->
    <ConfirmationModal :show="showConfirmModal" :message="`Are you sure you want to ${pendingStatusChange?.newStatus ? 'enable' : 'disable'} the ${pendingStatusChange?.field?.name} ${pendingStatusChange?.type}?`" @close="closeConfirmModal" @confirm="confirmStatusChange" />

    <!-- Delete Confirmation Modal -->
    <DeleteBlueprintConfirmationModal :show="showDeleteModal" @close="closeDeleteModal" @confirm="confirmDeleteBlueprint" />
  </div>
  <div v-else>
    <PermissionAlert />
  </div>
</template>

<script>
import { get, post, put, del } from '@/utils/api'
import { showToast } from '@/utils/toast'
import CustomHyperlink from '@/components/CustomHyperlink/CustomHyperlink.vue'
import SecondaryButton from '@/components/SecondaryButton/SecondaryButton.vue'
import ConfirmationModal from '@/components/ConfirmationModal/ConfirmationModal.vue'
import DeleteBlueprintConfirmationModal from '@/components/DeleteBlueprintConfirmationModal/DeleteBlueprintConfirmationModal.vue'
import PermissionAlert from '@/components/PermissionAlert.vue'
import uploadIcon from '@/assets/uploadicon.png'
import pdfIcon from '@/assets/pdficon.png'
import closeIcon from '@/assets/close.png'
import CustomDropdown from '@/components/CustomDropdown/CustomDropdown.vue'

export default {
  components: {
    CustomHyperlink,
    SecondaryButton,
    ConfirmationModal,
    DeleteBlueprintConfirmationModal,
    PermissionAlert,
    CustomDropdown,
  },
  data() {
    return {
      loading: false,
      loadingStates: {
        fetchClasses: false,
        saveClass: false,
        fetchBlueprints: false,
        saveBlueprint: false,
        fetchTenants: false,
      },
      readPermission: false,
      writePermission: false,
      // Dummy classes for testing/demo purposes
      classes: [],
      blueprints: [],
      tenants: [],
      selectedTenant: '',
      selectedClass: null,
      search: '',
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 1,
      pageSizeOptions: [10, 20, 50, 100],
      showPageSizeDropdown: false,
      showAddForm: false,
      editMode: false,
      editId: null,
      showErrors: false,
      showBlueprintErrors: false,
      errors: {
        name: '',
        description: '',
        project_id: '',
      },
      blueprintErrors: {
        name: '',
        description: '',
      },
      newClass: {
        name: '',
        description: '',
        project_id: '',
        is_active: true,
      },
      classSelectionMode: '',
      isCreatingNew: false,
      uploadedFiles: [],
      isDragging: false,
      fileErrorMessage: '',
      uploadIcon,
      pdfIcon,
      closeIcon,
      pendingStatusChange: null,
      showConfirmModal: false,
      showDeleteModal: false,
      blueprintToDelete: null,
      searchDebounceTimer: null,
    }
  },
  computed: {
    isLoading() {
      return Object.values(this.loadingStates).some((state) => state)
    },
    uniqueClassNames() {
      const names = this.classes.map((c) => c.name)
      return [...new Set(names)].sort()
    },
    filteredClasses() {
      if (!this.search || this.search.trim() === '') {
        return this.classes
      }

      const searchTerm = this.search.toLowerCase().trim()
      return this.classes.filter((docClass) => docClass?.ClassName?.toLowerCase().includes(searchTerm))
    },
    totalFiltered() {
      return this.filteredClasses.length
    },
    totalPagesFiltered() {
      return Math.ceil(this.totalFiltered / this.pageSize)
    },
  },
  mounted() {
    document.title = 'IDP Document Classes'
    this.checkPermissions()
    this.fetchTenants()
    this.fetchClasses()
    document.addEventListener('click', this.handleClickAway)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickAway)
  },
  methods: {
    checkPermissions() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      this.readPermission = permissions.some((p) => p.object_name === 'TENANT_CONFIGURE_RD' && p.is_active)
      this.writePermission = permissions.some((p) => p.object_name === 'TENANT_CONFIGURE_WR' && p.is_active)
    },

    async fetchTenants() {
      this.loadingStates.fetchTenants = true
      try {
        const response = await get('/v1/tenants?page=1&pageSize=1000')

        if (response?.data?.code === 200) {
          // Filter out Master Tenant
          this.tenants = (response.data.data.tenants || []).map((tenant) => ({
            label: tenant.tenant_name,
            value: tenant.id,
          }))
          // Auto-select first tenant if none selected
          if (this.tenants.length > 0 && !this.selectedTenant) {
            this.selectedTenant = this.tenants[0].value
            this.fetchClasses()
          }
        }
      } catch (err) {
      } finally {
        this.loadingStates.fetchTenants = false
      }
    },

    onTenantChange() {
      this.page = 1
      this.fetchClasses()
    },

    handleSearchInput() {
      // Clear existing timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }

      // Set new timer for 300ms debounce
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1 // Reset to first page when searching
        // No need to call API - filtering is done in computed property
      }, 300)
    },

    async fetchClasses() {
      this.loadingStates.fetchClasses = true
      try {
        const tenantId = this.selectedTenant?.value || this.selectedTenant
        if (!tenantId) return
        // let url = `/v1/classes?tenant_id=${this.selectedTenant}&page=${this.page}&pageSize=${this.pageSize}`
        let url = `/v1/bedrock/list-blueprints?tenantId=${tenantId}`
        // if (this.search) {
        //   url += `&search=${encodeURIComponent(this.search)}`
        // }
        const response = await get(url)
        if (response?.status === 200) {
          this.classes = response?.data?.blueprints?.sort((a, b) => a?.ClassName?.localeCompare(b?.ClassName))
          this.total = response?.data?.blueprints?.length
          this.totalPages = Math.ceil(this.total / this.pageSize)
        }
      } catch (err) {
      } finally {
        this.loadingStates.fetchClasses = false
      }
    },

    async fetchBlueprints() {
      if (!this.selectedClass) return

      this.loadingStates.fetchBlueprints = true
      try {
        const tenantId = this.selectedTenant?.value || this.selectedTenant
        const className = this.selectedClass.name
        const url = `/v1/bedrock/list-blueprints?tenantId=${tenantId}&className=${encodeURIComponent(className)}`

        const response = await get(url)

        if (response?.status === 200) {
          this.blueprints = response.data || []
          this.blueprintTotal = this.blueprints.length
          this.blueprintTotalPages = Math.ceil(this.blueprintTotal / this.blueprintPageSize)
        } else {
          throw new Error(response?.data?.message || 'Failed to fetch blueprints')
        }
      } catch (err) {
        showToast({
          title: 'Error',
          message: this.$t('blueprints.error_loading'),
          type: 'error',
        })
        this.blueprints = []
      } finally {
        this.loadingStates.fetchBlueprints = false
      }
    },

    handleClickAway(event) {
      const dropdownEl = this.$refs.dropdownEl
      if (dropdownEl && !dropdownEl.contains(event.target)) {
        this.showPageSizeDropdown = false
      }
    },

    handleClassStatusToggle(docClass, newValue) {
      this.pendingStatusChange = {
        field: { ...docClass },
        newStatus: newValue,
        type: 'class',
      }
      this.showConfirmModal = true
    },

    handleBlueprintStatusToggle(blueprint, newValue) {
      this.pendingStatusChange = {
        field: { ...blueprint },
        newStatus: newValue,
        type: 'blueprint',
      }
      this.showConfirmModal = true
    },

    closeConfirmModal() {
      this.showConfirmModal = false
      this.pendingStatusChange = null
    },

    async confirmStatusChange() {
      if (!this.pendingStatusChange) return

      const { field, newStatus, type } = this.pendingStatusChange

      if (type === 'class') {
        const updatedClass = this.classes.find((c) => c.id === field.id)
        if (updatedClass) {
          updatedClass.is_active = newStatus
          await this.updateClassStatus(updatedClass)
        }
      } else if (type === 'blueprint') {
        const updatedBlueprint = this.blueprints.find((b) => b.id === field.id)
        if (updatedBlueprint) {
          updatedBlueprint.is_active = newStatus
          await this.updateBlueprintStatus(updatedBlueprint)
        }
      }

      this.closeConfirmModal()
    },

    async updateClassStatus(selectedClass) {
      if (!selectedClass) return
      this.loadingStates.saveClass = true
      try {
        const payload = {
          name: selectedClass.name,
          description: selectedClass.description,
          project_id: selectedClass.project_id,
          is_active: Boolean(selectedClass.is_active),
          tenant_id: this.selectedTenant.value,
        }

        const response = await put(`/v1/classes/${selectedClass.id}`, payload)
        if (response?.data?.code === 200 || response?.data?.code === 201) {
          showToast({
            title: 'Success',
            message: `Class ${selectedClass.is_active ? 'enabled' : 'disabled'} successfully`,
            type: 'success',
          })
        } else {
          throw new Error(response?.data?.message || 'Failed to update class')
        }
      } catch (err) {
        showToast({
          title: 'Error',
          message: err.message || 'Failed to update class',
          type: 'error',
        })
      } finally {
        this.loadingStates.saveClass = false
      }
    },

    async updateBlueprintStatus(selectedBlueprint) {
      if (!selectedBlueprint) return
      this.loadingStates.saveBlueprint = true
      try {
        const payload = {
          name: selectedBlueprint.name,
          description: selectedBlueprint.description,
          is_active: Boolean(selectedBlueprint.is_active),
          class_id: this.selectedClass.id,
        }

        const response = await put(`/v1/blueprints/${selectedBlueprint.id}`, payload)
        if (response?.data?.code === 200 || response?.data?.code === 201) {
          showToast({
            title: 'Success',
            message: `Blueprint ${selectedBlueprint.is_active ? 'enabled' : 'disabled'} successfully`,
            type: 'success',
          })
        } else {
          throw new Error(response?.data?.message || 'Failed to update blueprint')
        }
      } catch (err) {
        showToast({
          title: 'Error',
          message: err.message || 'Failed to update blueprint',
          type: 'error',
        })
      } finally {
        this.loadingStates.saveBlueprint = false
      }
    },

    validateClassForm() {
      let isValid = true
      this.errors = {
        name: '',
        description: '',
        project_id: '',
      }

      if (!this.newClass.name?.trim()) {
        this.errors.name = 'Class name is required'
        isValid = false
      }

      if (!this.newClass.description?.trim()) {
        this.errors.description = 'Description is required'
        isValid = false
      }

      // Removed project_id validation since the field was removed from the form

      return isValid
    },

    validateBlueprintForm() {
      let isValid = true
      this.blueprintErrors = {
        name: '',
        description: '',
      }

      if (!this.newBlueprint.name?.trim()) {
        this.blueprintErrors.name = this.$t('blueprints.validation.name_required')
        isValid = false
      }

      if (!this.newBlueprint.description?.trim()) {
        this.blueprintErrors.description = this.$t('blueprints.validation.description_required')
        isValid = false
      }

      return isValid
    },

    handleAddClass() {
      const urlName = localStorage.getItem('url_name')
      this.$router.push(`/${urlName}/document-training`)
    },

    resetClassForm() {
      this.newClass = {
        name: '',
        description: '',
        project_id: '',
        is_active: true,
      }
      this.classSelectionMode = ''
      this.isCreatingNew = false
      this.uploadedFiles = []
      this.fileErrorMessage = ''
      this.showErrors = false
      this.errors = {
        name: '',
        description: '',
        project_id: '',
      }
    },

    resetBlueprintForm() {
      this.newBlueprint = {
        name: '',
        description: '',
        is_active: true,
      }
      this.showBlueprintErrors = false
      this.blueprintErrors = {
        name: '',
        description: '',
      }
    },

    cancelAdd() {
      this.showAddForm = false
      this.resetClassForm()
    },

    handleStatusChange(value) {
      this.newClass.is_active = value
    },

    onClassSelectionChange() {
      if (this.classSelectionMode) {
        this.newClass.name = this.classSelectionMode
      } else {
        this.newClass.name = ''
      }
    },

    toggleCreateNew() {
      this.isCreatingNew = true
      this.classSelectionMode = ''
      this.newClass.name = ''
    },

    cancelCreateNew() {
      this.isCreatingNew = false
      this.newClass.name = ''
    },

    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    handleDragOver(e) {
      this.isDragging = true
      e.dataTransfer.dropEffect = 'copy'
    },

    handleDragLeave() {
      this.isDragging = false
    },

    handleDrop(e) {
      this.isDragging = false
      const files = Array.from(e.dataTransfer.files)
      this.validateAndAddFiles(files)
    },

    handleFileUpload(event) {
      const files = Array.from(event.target.files)
      this.validateAndAddFiles(files)
      event.target.value = '' // Reset input
    },

    validateAndAddFiles(files) {
      this.fileErrorMessage = '' // Clear previous error

      const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff']
      const maxSize = 5 * 1024 * 1024 // 5MB

      for (const file of files) {
        if (!allowedTypes.includes(file.type)) {
          this.fileErrorMessage = `File "${file.name}" is not a supported file type. Only PDF, PNG, JPEG, and TIFF files are allowed.`
          setTimeout(() => {
            this.fileErrorMessage = ''
          }, 5000)
          continue
        }

        if (file.size > maxSize) {
          this.fileErrorMessage = `File "${file.name}" is too large. Maximum file size is 5MB.`
          setTimeout(() => {
            this.fileErrorMessage = ''
          }, 5000)
          continue
        }

        this.uploadedFiles.push(file)
      }
    },

    removeFile(index) {
      this.uploadedFiles.splice(index, 1)
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)))
      return Math.round(bytes / Math.pow(k, i)) + ' ' + sizes[i]
    },

    handleBlueprintStatusChange(value) {
      this.newBlueprint.is_active = value
    },

    async saveClass() {
      this.showErrors = true
      if (!this.validateClassForm()) {
        return
      }

      // Check if files are uploaded for document training
      if (this.uploadedFiles.length === 0) {
        showToast({
          title: 'Error',
          message: 'Please upload at least one document for training',
          type: 'error',
        })
        return
      }

      this.loadingStates.saveClass = true
      try {
        // First upload the document for training
        const uploadPromises = this.uploadedFiles.map((file) => {
          return uploadDocument(file)
        })
        const uploadResults = await Promise.all(uploadPromises)

        // Store upload results in localStorage for the Document Training page
        const documentTrainingData = {
          className: this.newClass.name,
          description: this.newClass.description,
          uploadResults: uploadResults,
          timestamp: new Date().toISOString(),
        }

        localStorage.setItem('documentTrainingData', JSON.stringify(documentTrainingData))

        showToast({
          title: 'Success',
          message: 'Document uploaded successfully. Redirecting to Document Training...',
          type: 'success',
        })

        // Navigate to Document Training page
        setTimeout(() => {
          const tenantName = localStorage.getItem('url_name')
          this.$router.push(`/${tenantName}/document-training`)
        }, 1500)
      } catch (err) {
        const errorMessage = err.response?.data?.message || err.message
        showToast({
          title: 'Error',
          message: errorMessage || 'Failed to upload document',
          type: 'error',
        })
      } finally {
        this.loadingStates.saveClass = false
      }
    },

    editClass(docClass) {
      this.editMode = true
      this.editId = docClass.id
      this.showAddForm = true
      this.newClass = {
        name: docClass.name,
        description: docClass.description,
        project_id: docClass.project_id,
        is_active: docClass.is_active,
      }
    },

    viewBlueprints(docClass) {
      this.selectedClass = docClass
      this.showBlueprintModal = true
      this.blueprintPage = 1
      this.fetchBlueprints()
    },

    async addBlueprint(docClass) {
      this.selectedClass = { name: docClass }
      this.showBlueprintModal = true
      this.showAddBlueprintForm = false
      this.blueprintEditMode = false
      this.resetBlueprintForm()
      await this.fetchBlueprints()
    },

    closeBlueprintModal() {
      this.showBlueprintModal = false
      this.showAddBlueprintForm = false
      this.selectedClass = null
      this.blueprints = []
    },

    showAddBlueprintFormMethod() {
      this.showAddBlueprintForm = true
      this.blueprintEditMode = false
      this.resetBlueprintForm()
    },

    cancelAddBlueprint() {
      this.showAddBlueprintForm = false
      this.resetBlueprintForm()
    },

    async saveBlueprint() {
      this.showBlueprintErrors = true
      if (!this.validateBlueprintForm()) {
        return
      }

      this.loadingStates.saveBlueprint = true
      try {
        const payload = {
          name: this.newBlueprint.name,
          description: this.newBlueprint.description,
          is_active: this.newBlueprint.is_active,
          class_id: this.selectedClass.id,
        }

        let response
        if (this.blueprintEditMode) {
          response = await put(`/v1/blueprints/${this.blueprintEditId}`, payload)
        } else {
          response = await post('/v1/blueprints', payload)
        }

        if (response?.data?.code === 200 || response?.data?.code === 201) {
          showToast({
            title: 'Success',
            message: this.blueprintEditMode ? this.$t('blueprints.update_success') : this.$t('blueprints.save_success'),
            type: 'success',
          })
          this.showAddBlueprintForm = false
          this.resetBlueprintForm()
          await this.fetchBlueprints()
        } else {
          throw new Error(response?.data?.message || this.$t('blueprints.error_loading'))
        }
      } catch (err) {
        const errorMessage = err.response?.data?.message || err.message
        showToast({
          title: 'Error',
          message: errorMessage || this.$t('blueprints.error_loading'),
          type: 'error',
        })
      } finally {
        this.loadingStates.saveBlueprint = false
      }
    },

    editBlueprint(blueprint) {
      // Navigate to the edit blueprint page
      this.$router.push({
        name: 'EditBlueprint',
        params: { id: blueprint.id },
      })
    },

    togglePageSizeDropdown() {
      this.showPageSizeDropdown = !this.showPageSizeDropdown
    },

    async selectPageSize(size) {
      this.pageSize = size
      this.page = 1
      this.showPageSizeDropdown = false
      await this.fetchClasses()
    },

    async goToPreviousPage() {
      if (this.page > 1) {
        this.page--
        await this.fetchClasses()
      }
    },

    async goToNextPage() {
      if (this.page < this.totalPages) {
        this.page++
        await this.fetchClasses()
      }
    },

    handleFieldChange(fieldName, value) {
      if (this.errors[fieldName]) {
        this.errors[fieldName] = ''
      }
      if (typeof value !== 'undefined') {
        this.newClass[fieldName] = value
      }
    },

    handleBlueprintFieldChange(fieldName, value) {
      if (this.blueprintErrors[fieldName]) {
        this.blueprintErrors[fieldName] = ''
      }
      if (typeof value !== 'undefined') {
        this.newBlueprint[fieldName] = value
      }
    },
    // New methods for blueprint actions
    viewBlueprint(blueprint) {
      // Navigate to view blueprint screen
      const urlName = localStorage.getItem('url_name')
      this.$router.push(`/${urlName}/document-training`)
    },

    editBlueprint(blueprint) {
      // Navigate to edit blueprint screen
      const urlName = localStorage.getItem('url_name')
      this.$router.push(`/${urlName}/document-training`)
    },

    deleteBlueprint(blueprint) {
      this.blueprintToDelete = blueprint
      this.showDeleteModal = true
    },

    closeDeleteModal() {
      this.showDeleteModal = false
      this.blueprintToDelete = null
    },

    async confirmDeleteBlueprint() {
      if (!this.blueprintToDelete) return

      try {
        const response = await del(`/v1/bedrock/delete-blueprint?tenantId=${this?.selectedTenant}&blueprintArn=${this?.blueprintToDelete?.BlueprintArn}`)

        if (response?.status === 200) {
          showToast({
            title: 'Success',
            message: 'Deleted successfully',
            type: 'success',
          })
          // Refresh the classes list
          this.fetchClasses()
        } else {
          throw new Error(response?.data?.message || 'Failed to delete')
        }
      } catch (err) {
        showToast({
          title: 'Error',
          message: err.message || 'Failed to delete',
          type: 'error',
        })
      } finally {
        this.closeDeleteModal()
      }
    },
  },

  watch: {
    selectedTenant(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.page = 1 // reset to first page when tenant changes
        this.fetchClasses()
      }
    },
    'newClass.name'(value) {
      this.handleFieldChange('name', value)
    },
    'newClass.description'(value) {
      this.handleFieldChange('description', value)
    },
    'newClass.project_id'(value) {
      this.handleFieldChange('project_id', value)
    },
    'newBlueprint.name'(value) {
      this.handleBlueprintFieldChange('name', value)
    },
    'newBlueprint.description'(value) {
      this.handleBlueprintFieldChange('description', value)
    },
  },
}
</script>

<style scoped>
/* Import global styles */
@import '@/styles/global.css';

/* Reuse styles from Models.vue */
.searchBar {
  display: flex;
  align-items: center;
  width: 386px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid #dadada;
  background: #fff;
  padding: 0 10px;
  gap: 10px;
  position: relative;
}

.headerActions {
  display: flex;
  gap: 20px;
  align-items: center;
}

.tenantSelector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tenantSelector label {
  font-weight: 500;
  color: #32393e;
}

.tenantDropdown {
  padding: 8px 12px;
  border: 1px solid #dadada;
  border-radius: 6px;
  background: #fff;
  min-width: 200px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 25px;
  margin-bottom: 25px;
}

.searchInput {
  border: none;
  outline: none;
  width: 100%;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #8f969b;
}

.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 6px 6px;
  padding: 8px 12px;
  font-size: 12px;
  color: #6b7280;
  z-index: 10;
}

.search-count {
  font-family: 'Lato', sans-serif;
}

.button-group {
  margin-top: 20px;
  display: flex;
  gap: 20px;
}

.cancel-btn {
  padding: 10px 32px;
  background: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
}

.create-new-btn {
  padding: 5px 10px;
  background: var(--primary-color);
  color: white;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.save-btn {
  padding: 10px 32px;
  background: var(--primary-color);
  color: white;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.form-field label {
  color: #8b8888;
  font-family: 'Lato', sans-serif;
  font-size: 18px;
  font-weight: 400;
  display: block;
  margin-bottom: 6px;
}

.form-field {
  width: 100%;
}

.form-field input,
.form-field select {
  width: 100%;
  height: 47px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  color: #32393e;
}

.newPageTitle {
  color: var(--primary-color);
  font-family: 'Lato', sans-serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 150%;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
}

.error-border {
  border-color: #dc3545 !important;
}

.createModelBody {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.createModelHeader {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 9px;
}

.pageDiv {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #ccc;
  padding: 6px 12px;
  border-radius: 4px;
  background: #fff;
}

.pageSizeDropdownNew {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 4px;
  list-style: none;
  padding: 4px 0;
  width: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.pageSizeDropdownNew li {
  padding: 6px 12px;
  cursor: pointer;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  color: #5c656c;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: 80%;
  max-height: 80%;
  overflow-y: auto;
  padding: 20px;
  position: relative;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.modal-header h3 {
  margin: 0;
  color: var(--primary-color);
  font-family: 'Lato', sans-serif;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.close-btn:hover {
  color: #000;
}

.modal-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.blueprint-controls {
  display: flex;
  justify-content: flex-end;
}

.blueprint-form {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.blueprints-table {
  width: 100%;
}

.toggle-wrapper {
  display: flex;
  align-items: center;
}

/* Upload area styles */
.uploadDivBorder {
  padding: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  border-radius: 8px;
  border: 1px dashed #667085;
  cursor: pointer;
  transition: all 0.3s ease;
}

.uploadDivBorder:hover {
  border-color: var(--primary-color);
  background-color: rgba(22, 72, 99, 0.02);
}

.uploadDivBorder.drag-over {
  border-color: var(--primary-color);
  background-color: rgba(22, 72, 99, 0.05);
}

.labelParagraph {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subPageLabel {
  color: #32393e;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.clickUploadLabel {
  color: var(--primary-color);
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  text-decoration: underline;
  margin-left: 5px;
}

.smallLabel {
  color: #9a9a9a;
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  margin-top: 5px;
}

.uploaded-files-section {
  margin-top: 20px;
}

.files-container {
  max-height: 200px;
  overflow-y: auto;
}

.file-item {
  display: flex;
  width: 100%;
  height: 68px;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #dbdbdb;
  background: #fff;
  margin-bottom: 12px;
  padding: 16px;
}

.file-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.file-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.file-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-grow: 1;
}

.file-name {
  color: #32393e;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}

.file-size {
  color: #5c656c;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  margin-top: 6px;
  line-height: 14px;
}

.remove-file {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-left: auto;
  cursor: pointer;
}

.error-message {
  color: #dc2626;
  font-size: 14px;
  background-color: #fee2e2;
}

/* Blueprint Modal Styles */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
}

.loading-state p {
  margin-top: 16px;
  color: #666;
  font-family: 'Lato', sans-serif;
}

.no-blueprints {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
}

.no-blueprints p {
  color: #666;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
}

.error-text {
  color: #dc2626;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.error-border {
  border-color: #dc2626 !important;
}

/* Action buttons styling */
.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-link {
  color: var(--primary-color);
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
}

.action-link:hover {
  text-decoration: underline;
}

.delete-link {
  color: #dc2626;
}

.delete-link:hover {
  color: #b91c1c;
}
</style>
